<template>
  <v-container fluid grid-list-md>
    <v-layout column px-6 py-3>
      <v-row class="d-flex justify-center">
        <v-col class="mb-4" cols="12">
          <span class="page-title font-weight-bold">{{ title }}</span>
        </v-col>
        <slot name="search"/>
        <slot name="table"/>
        <slot name="content"/>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "PageLayout",
  props: ["title"]
}
</script>

<style>
.page-title {
  font-size: min(7vw, 32px);
}
</style>